import { useTranslation } from "react-i18next";
import styles from "./Loader.module.css";

const Loader = ({ text, fullscreen = false }) => {
  const { t } = useTranslation();
  const displayText = text ?? t("common.loading");

  if (fullscreen) {
    return (
      <div className={styles.overlay}>
        <div className={styles.card}>
          <div className={styles.spinnerWrap}>
            <div className={styles.spinner} />
            <div className={styles.spinnerInner} />
          </div>
          <div className={styles.text}>{displayText}</div>
          <div className={styles.subTextWrap}>
            <span className={styles.subText}>{t("common.pleaseWait")}</span>
            <span className={styles.dots} aria-hidden>
              <span />
              <span />
              <span />
            </span>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.inline}>
      <div className={styles.spinnerSmall} />
      <span className={styles.text}>{displayText}</span>
    </div>
  );
};

export default Loader;
